import { ISavedFilter } from '@common/interfaces/savedFilter'
import { combineReducers } from 'redux'
import { createLoadingDataReducer } from '../../helpers/redux'
import * as actions from './actions'

// One table's list at a time. Mutations flip isSaving; the caller refetches the list
// on their success so pill order comes straight from the server.
const savedFiltersData = createLoadingDataReducer<ISavedFilter[] | null>(
  [actions.LIST_SAVED_FILTERS_REQUEST],
  [
    actions.CREATE_SAVED_FILTER_REQUEST,
    actions.UPDATE_SAVED_FILTER_REQUEST,
    actions.DELETE_SAVED_FILTER_REQUEST,
  ],
)

export default combineReducers({
  savedFiltersData,
})
